import { render, staticRenderFns } from "./ProductListSummary.vue?vue&type=template&id=6955d36f&"
import script from "./ProductListSummary.vue?vue&type=script&lang=ts&"
export * from "./ProductListSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports